import { createAsyncAction,  createAction} from 'typesafe-actions';
import { ErrorMessage, CMSShipData, CMSPortData } from '../../services/types';


export const loadShips = createAsyncAction(
  'Broken',
  'LOAD_SHIP_SUCCESS',
  'LOAD_SHIP_FAILURE'
)<undefined, CMSShipData[], ErrorMessage>();

export const loadPorts = createAsyncAction(
  'LOAD_PORTS_REQUEST',
  'LOAD_PORTS_SUCCESS',
  'LOAD_PORTS_FAILURE'
)<string, CMSPortData[], ErrorMessage>();

export const loadShipsRequest = createAction('LOAD_SHIP_REQUEST')();
